import { InvoicePaymentMethod } from '@models/Invoice'
import { capitalize } from '@helpers/display'
import { InfinitePaymentMethodDefinition, PaymentMethodsDefinitionInterface } from './PaymentDefinition'
import { CurrencyCode, Money } from '@models/Money'
import { PaymentSources } from '@models/PaymentMethod'
import { MoneyCalc, Zero } from '@helpers/money'
import { FORTIS_CREDIT_ADDITIONAL_FEE, FORTIS_CREDIT_CARD_FEE_PERCENT } from '../../../constants/CONSTANTS'

/** Our implementation of online credit card processing through Fortis */
export class FortisCreditOnlinePaymentDefinition
  extends InfinitePaymentMethodDefinition<PaymentSources.FORTIS_CARD_ONLINE>
  implements PaymentMethodsDefinitionInterface<PaymentSources.FORTIS_CARD_ONLINE>
{
  chargePlatformFee = true
  constructor() {
    super(PaymentSources.FORTIS_CARD_ONLINE, 'Card')
  }

  calculateFee(amount: Money) {
    // If the amount to charge fees on is Zero then don't charge any fees. Without this it will charge the flat fee like $0.30
    if (MoneyCalc.isZero(amount)) return Zero

    const percentageFee = MoneyCalc.math(Math.ceil, MoneyCalc.multiply(amount, FORTIS_CREDIT_CARD_FEE_PERCENT / 100))

    // Add the additional $0.30 Fortis charges on top of the percentage
    return MoneyCalc.add(percentageFee, FORTIS_CREDIT_ADDITIONAL_FEE)
  }

  formatInvPayMethod({ last4, card_type }: InvoicePaymentMethod<PaymentSources.STRIPE>) {
    const baseStr = capitalize(card_type) ?? this.formatShort()

    if (last4) return `${baseStr} *${last4}`
    return baseStr
  }

  /** We will not use Fortis in Canada for initial release, if we support it in the future we can re-enable here */
  hasCurrencySupport(currency: CurrencyCode): boolean {
    return ['usd'].includes(currency)
  }
}
